import { render } from "./DialogBookRefundConfirmation.vue?vue&type=template&id=097d35e2&scoped=true"
import script from "./DialogBookRefundConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogBookRefundConfirmation.vue?vue&type=script&lang=js"

import "./DialogBookRefundConfirmation.vue?vue&type=style&index=0&id=097d35e2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-097d35e2"

export default script